import { render, staticRenderFns } from "./TaskSettingsPanel.vue?vue&type=template&id=4e84b1f5&scoped=true"
import script from "./TaskSettingsPanel.vue?vue&type=script&lang=js"
export * from "./TaskSettingsPanel.vue?vue&type=script&lang=js"
import style0 from "./TaskSettingsPanel.vue?vue&type=style&index=0&id=4e84b1f5&prod&lang=scss&scoped=true"
import style1 from "./TaskSettingsPanel.vue?vue&type=style&index=1&id=4e84b1f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e84b1f5",
  null
  
)

export default component.exports